import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { errorToast } from "../../../components/toastmessage/toastmessage";
import { fetchInsuranceApiCall } from "./insuranceService";


const useInsuranceTableHook = () => {
    const navigate = useNavigate();
    const [insuranceState, setInsuranceState] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const fetchInsurance = async () => {
            setLoader(true)
            try {
                let result = await fetchInsuranceApiCall();
                if (result.status === 200) {
                    setLoader(false)
                    setInsuranceState(result?.data?.result)
                }
            } catch (e) {
                setLoader(false)
                errorToast("Failed to fetch Rooms")
            }

        }
        fetchInsurance();

    }, []);

    const handleDelete = (e, id) => {
        e.preventDefault();
        setInsuranceState(oldValues => {
            return oldValues.filter(room => room?.uniqueId !== id?.uniqueId)
        });
    };

    const handleGetRowId = (e) => {
        return e?.uniqueId
    }

    const handleInsurance = () => {
        navigate("/master/add-insurance")
    }
    return {
        loader,
        insuranceState,
        handleGetRowId,
        handleDelete,
        handleInsurance
    }


};


export default useInsuranceTableHook;
